import * as IMask from 'imask';

export class IntegerMask {

    private input: HTMLInputElement = null;

    private iMask: IMask = null;

    // ########################################

    constructor(
        input: HTMLInputElement,
        iMask: IMask
    ) {
        this.input = input;
        this.iMask = iMask;
    }

    // ########################################

    public updateMask(mask: string): void {
        this.iMask.updateOptions({
            mask: `${mask}`
        });
    }

    // ########################################
}
